import { Injectable } from '@angular/core';
import { Observable ,  Subscriber } from 'rxjs';
import { ModalParams } from '../modal-params';
import { share } from 'rxjs/operators';


@Injectable()
export class ModalService {

  private openEmitter: Subscriber<ModalParams>;
  private openObservable: Observable<ModalParams>;

  private resolveEmitter: Subscriber<void>;
  private triggerResolutionEmitter: Subscriber<void>;
  private triggerResolutionObservable: Observable<void>;
  private triggerCloseEmitter: Subscriber<void>;
  private triggerCloseObservable: Observable<void>;

  constructor() {
    this.openObservable = new Observable<ModalParams>(e => this.openEmitter = e).pipe(share());
    this.triggerResolutionObservable = new Observable<void>(e => this.triggerResolutionEmitter = e).pipe(share());
    this.triggerCloseObservable = new Observable<void>(e => this.triggerCloseEmitter = e).pipe(share());
  }

  getOpenObservable(): Observable<ModalParams> {
    return this.openObservable;
  }

  getTriggerResolutionObservable(): Observable<void> {
    return this.triggerResolutionObservable;
  }

  getTriggerCloseObservable(): Observable<void> {
    return this.triggerCloseObservable;
  }

  getResolveEmitter(): Subscriber<void> {
    return this.resolveEmitter;
  }

  open(params: ModalParams): Observable<void> {
    this.openEmitter.next(params);

    return new Observable(e => this.resolveEmitter = e);
  }

  triggerResolution() {
    this.triggerResolutionEmitter.next();
  }

  triggerClose() {
    this.triggerCloseEmitter.next();
  }
}
